export default __webpack_public_path__ + "de9d39d0899648cb29ab7ffd2b305872.png";